var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"panel-body"},[_c('VueFormGenerator',{attrs:{"schema":_vm.schema,"model":_vm.data,"options":_vm.formOptions},on:{"model-updated":_vm.modelUpdated,"validated":_vm.onValidated}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }